import { useNavigate } from 'react-router-dom';

/** Shown when a URL names something that doesn't exist, instead of silently serving the first item. */
export default function NotFoundBlock({ title, message, backLabel, backTo }) {
  const navigate = useNavigate();
  return (
    <div className="wrap" style={{ padding:'80px 0 96px', textAlign:'center' }}>
      <div style={{ width:74, height:74, borderRadius:24, margin:'0 auto 18px', background:'rgba(14,138,122,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:30 }}>🧭</div>
      <h1 className="serif" style={{ fontSize:34, marginBottom:12 }}>{title}</h1>
      <p style={{ fontSize:16, color:'#5a726f', maxWidth:'44ch', margin:'0 auto 24px', lineHeight:1.6 }}>{message}</p>
      <span onClick={() => navigate(backTo)} className="btn btn-teal" style={{ cursor:'pointer', padding:'14px 26px' }}>{backLabel}</span>
    </div>
  );
}
